/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {ChessConsolePlayer} from "../../../lib/chess-console/ChessConsolePlayer.js"
import {Chess} from "../../../lib/cm-chess/Chess.js"

export class GambitRemotePlayer extends ChessConsolePlayer {
    constructor(chessConsole, name, props) {
        super(chessConsole, name, props)
        this.currentMoveResponse = undefined
    }

    onMove(move) {
        const tmpChess = new Chess(this.chessConsole.state.chess.fen())
        const result = tmpChess.move(move.move)
        if (result) {
            this.currentMoveResponse(result)
            this.currentMoveResponse = undefined
        } else {
            console.warn("san", move.alg, "is not valid for", this.chessConsole.state.chess.fen())
        }
    }

    moveRequest(fen, moveResponse) {
        if (this.currentMoveResponse) {
            console.warn("currentMoveResponse != undefined")
        }
        this.currentMoveResponse = moveResponse
    }
}
